import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { EstadoMultiselectComponent } from './estado-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        EstadoMultiselectComponent
    ],
    exports: [
        EstadoMultiselectComponent
    ]
})
export class EstadoMultiselectModule { }
